"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UPDATE;
(function (UPDATE) {
    UPDATE["updateAuthorizationState"] = "updateAuthorizationState";
    UPDATE["updateNewMessage"] = "updateNewMessage";
    UPDATE["updateMessageSendAcknowledged"] = "updateMessageSendAcknowledged";
    UPDATE["updateMessageSendSucceeded"] = "updateMessageSendSucceeded";
    UPDATE["updateMessageSendFailed"] = "updateMessageSendFailed";
    UPDATE["updateMessageContent"] = "updateMessageContent";
    UPDATE["updateMessageEdited"] = "updateMessageEdited";
    UPDATE["updateMessageViews"] = "updateMessageViews";
    UPDATE["updateMessageContentOpened"] = "updateMessageContentOpened";
    UPDATE["updateMessageMentionRead"] = "updateMessageMentionRead";
    UPDATE["updateNewChat"] = "updateNewChat";
    UPDATE["updateChatTitle"] = "updateChatTitle";
    UPDATE["updateChatPhoto"] = "updateChatPhoto";
    UPDATE["updateChatPermissions"] = "updateChatPermissions";
    UPDATE["updateChatLastMessage"] = "updateChatLastMessage";
    UPDATE["updateChatOrder"] = "updateChatOrder";
    UPDATE["updateChatIsPinned"] = "updateChatIsPinned";
    UPDATE["updateChatIsMarkedAsUnread"] = "updateChatIsMarkedAsUnread";
    UPDATE["updateChatIsSponsored"] = "updateChatIsSponsored";
    UPDATE["updateChatDefaultDisableNotification"] = "updateChatDefaultDisableNotification";
    UPDATE["updateChatReadInbox"] = "updateChatReadInbox";
    UPDATE["updateChatReadOutbox"] = "updateChatReadOutbox";
    UPDATE["updateChatUnreadMentionCount"] = "updateChatUnreadMentionCount";
    UPDATE["updateChatNotificationSettings"] = "updateChatNotificationSettings";
    UPDATE["updateScopeNotificationSettings"] = "updateScopeNotificationSettings";
    UPDATE["updateChatPinnedMessage"] = "updateChatPinnedMessage";
    UPDATE["updateChatReplyMarkup"] = "updateChatReplyMarkup";
    UPDATE["updateChatDraftMessage"] = "updateChatDraftMessage";
    UPDATE["updateChatOnlineMemberCount"] = "updateChatOnlineMemberCount";
    UPDATE["updateNotification"] = "updateNotification";
    UPDATE["updateNotificationGroup"] = "updateNotificationGroup";
    UPDATE["updateActiveNotifications"] = "updateActiveNotifications";
    UPDATE["updateHavePendingNotifications"] = "updateHavePendingNotifications";
    UPDATE["updateDeleteMessages"] = "updateDeleteMessages";
    UPDATE["updateUserChatAction"] = "updateUserChatAction";
    UPDATE["updateUserStatus"] = "updateUserStatus";
    UPDATE["updateUser"] = "updateUser";
    UPDATE["updateBasicGroup"] = "updateBasicGroup";
    UPDATE["updateSupergroup"] = "updateSupergroup";
    UPDATE["updateSecretChat"] = "updateSecretChat";
    UPDATE["updateUserFullInfo"] = "updateUserFullInfo";
    UPDATE["updateBasicGroupFullInfo"] = "updateBasicGroupFullInfo";
    UPDATE["updateSupergroupFullInfo"] = "updateSupergroupFullInfo";
    UPDATE["updateServiceNotification"] = "updateServiceNotification";
    UPDATE["updateFile"] = "updateFile";
    UPDATE["updateFileGenerationStart"] = "updateFileGenerationStart";
    UPDATE["updateFileGenerationStop"] = "updateFileGenerationStop";
    UPDATE["updateCall"] = "updateCall";
    UPDATE["updateUserPrivacySettingRules"] = "updateUserPrivacySettingRules";
    UPDATE["updateUnreadMessageCount"] = "updateUnreadMessageCount";
    UPDATE["updateUnreadChatCount"] = "updateUnreadChatCount";
    UPDATE["updateOption"] = "updateOption";
    UPDATE["updateInstalledStickerSets"] = "updateInstalledStickerSets";
    UPDATE["updateTrendingStickerSets"] = "updateTrendingStickerSets";
    UPDATE["updateRecentStickers"] = "updateRecentStickers";
    UPDATE["updateFavoriteStickers"] = "updateFavoriteStickers";
    UPDATE["updateSavedAnimations"] = "updateSavedAnimations";
    UPDATE["updateSelectedBackground"] = "updateSelectedBackground";
    UPDATE["updateLanguagePackStrings"] = "updateLanguagePackStrings";
    UPDATE["updateConnectionState"] = "updateConnectionState";
    UPDATE["updateTermsOfService"] = "updateTermsOfService";
    UPDATE["updateNewInlineQuery"] = "updateNewInlineQuery";
    UPDATE["updateNewChosenInlineResult"] = "updateNewChosenInlineResult";
    UPDATE["updateNewCallbackQuery"] = "updateNewCallbackQuery";
    UPDATE["updateNewInlineCallbackQuery"] = "updateNewInlineCallbackQuery";
    UPDATE["updateNewShippingQuery"] = "updateNewShippingQuery";
    UPDATE["updateNewPreCheckoutQuery"] = "updateNewPreCheckoutQuery";
    UPDATE["updateNewCustomEvent"] = "updateNewCustomEvent";
    UPDATE["updateNewCustomQuery"] = "updateNewCustomQuery";
    UPDATE["updatePoll"] = "updatePoll";
})(UPDATE = exports.UPDATE || (exports.UPDATE = {}));
